// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import atSignIcon from "@/assets/icons/at-sign.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type AtSignIconProps = Omit<IconProps, "name">;

export function AtSignIcon(props: AtSignIconProps): React.ReactNode {
  return <Icon name={atSignIcon} {...props} />;
}
